import React from 'react'
import SpinnerButton from '../../common/spinner-button'
import { Button } from 'react-bootstrap'
import CSVReader from 'react-csv-reader'
import RecordColumnMapper from './record-column-mapper'
import useCreateUsersMutation from './use-create-users-mutation'
import RolesSelector from '../create-form/roles-selector'

const ImportUsersForm = ({
    onComplete = () => {}
}) => {

    const {
        records,
        setRecords,
        users,
        setUsers,
        rolesCode,
        setRolesCode,
        createUsers,
        isCreatingUsers
    } = useCreateUsersMutation({ onSuccess: onComplete })

    let addButtonTitle = isCreatingUsers ? `Adding ${users.length} Users...` : `Add ${users.length} Users`

    return (
        <div style={{ paddingTop: '20px', display: 'flex', flexDirection: 'column' }}>
            <div>
                <RolesSelector
                    value={{ rolesCode }}
                    onChange={o => setRolesCode(o.rolesCode)}
                />
            </div>
            <div>
                <CSVReader
                    parserOptions={{ header:false }}
                    onFileLoaded={setRecords}
                    onError={(error) => console.log('ERROR:', error)}
                />
            </div>
            <div style={{ flexGrow: '1', display: records ? '' : 'none'  }}>
                <RecordColumnMapper records={records} onChange={setUsers} />
            </div>



            <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '20px'}}>
                <Button variant="link" onClick={() => onComplete()}>Discard</Button>
                <SpinnerButton busy={isCreatingUsers} disabled={isCreatingUsers || !users.length} onClick={() => createUsers()}>{addButtonTitle}</SpinnerButton>
            </div>
        </div>
    )
}

export default ImportUsersForm